// apps/admin/src/components/ui/ConfirmDialog.tsx
//
// Admin-local wrapper over the shared `@printway/ui` ConfirmDialog that fills in
// a TRANSLATED cancel label.
//
// dbg-20260725-uat-fin-2629-2632 (#2631 bước 8 + repo-wide): the shared
// component is deliberately i18n-agnostic — packages/ui carries no i18n, so it
// documents that "the consumer passes t()-translated copy" and keeps English
// fallbacks purely so an omission can't crash. `cancelLabel` defaults to the
// literal 'Cancel'. 40 admin call sites never passed one, so every one of those
// dialogs rendered an English cancel button even with locale = vi/fr — a
// mixed-locale modal, which is exactly what the fallback was meant to avoid.
//
// Fixing it at each call site would mean 40 edits plus a `cancel` key in 10
// separate namespaces, and the next new ConfirmDialog would regress it again.
// This wrapper fixes it once and keeps the shared component untouched: the
// admin app imports ConfirmDialog from here, and the default cancel label comes
// from `admin:common.cancel` (present in en/vi/fr). Callers can still pass an
// explicit `cancelLabel` — an explicit value always wins.
//
// Everything else (props, behaviour, `confirmLabel`, `type`, `loading`) is the
// shared component verbatim; this only supplies a default.

import type { JSX } from 'react';

import {
  ConfirmDialog as UiConfirmDialog,
  type ConfirmDialogProps,
} from '@printway/ui';

import { useTranslation } from '../../i18n/useTranslation.js';

export type { ConfirmDialogProps, ConfirmType } from '@printway/ui';

export function ConfirmDialog(props: ConfirmDialogProps): JSX.Element {
  const { t } = useTranslation('admin');
  return (
    <UiConfirmDialog
      {...props}
      cancelLabel={props.cancelLabel ?? t('common.cancel')}
    />
  );
}

export default ConfirmDialog;
